import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Import Auth
import Globe from "react-globe.gl";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import "./Landing.css";

function Landing() {
  const navigate = useNavigate();
  const { user } = useAuth(); // Use Global Auth State
  const globeEl = useRef();
  const [windowSize, setWindowSize] = useState({
    w: window.innerWidth,
    h: window.innerHeight,
  });

  // Handle Resize
  useEffect(() => {
    const handleResize = () =>
      setWindowSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Configure Globe
  useEffect(() => {
    if (globeEl.current) {
      globeEl.current.controls().autoRotate = true;
      globeEl.current.controls().autoRotateSpeed = 0.5;
      globeEl.current.pointOfView({ lat: 25, lng: 0, altitude: 2.2 });
    }
  }, []);

  const markerData = [
    { lat: 38.7223, lng: -9.1393, name: "Lisbon", size: 0.5, color: "#fff" },
    { lat: 25.2048, lng: 55.2708, name: "Dubai", size: 0.5, color: "#fff" },
    {
      lat: 1.3521,
      lng: 103.8198,
      name: "Singapore",
      size: 0.5,
      color: "#38bdf8",
    },
    { lat: 59.437, lng: 24.7536, name: "Tallinn", size: 0.5, color: "#38bdf8" },
    { lat: -8.4095, lng: 115.1889, name: "Bali", size: 0.5, color: "#fff" },
    {
      lat: 19.4326,
      lng: -99.1332,
      name: "Mexico City",
      size: 0.5,
      color: "#38bdf8",
    },
  ];

  const arcData = [
    {
      startLat: 37.7749,
      startLng: -122.4194,
      endLat: 38.7223,
      endLng: -9.1393,
      color: "rgba(255,255,255,0.2)",
    },
    {
      startLat: 51.5074,
      startLng: -0.1278,
      endLat: 25.2048,
      endLng: 55.2708,
      color: "rgba(255,255,255,0.2)",
    },
  ];

  return (
    <div className="landing">
      <div className="globe-layer">
        <Globe
          ref={globeEl}
          width={windowSize.w}
          height={windowSize.h}
          globeImageUrl="//unpkg.com/three-globe/example/img/earth-dark.jpg"
          bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
          backgroundColor="rgba(0,0,0,0)"
          atmosphereColor="#4f46e5"
          atmosphereAltitude={0.15}
          pointsData={markerData}
          pointAltitude={0.05}
          pointColor="color"
          pointRadius="size"
          pointPulseGm={1.5}
          pointsMerge={true}
          arcsData={arcData}
          arcColor="color"
          arcDashLength={0.4}
          arcDashGap={0.2}
          arcDashAnimateTime={3000}
          arcStroke={0.5}
        />
        <div className="gradient-overlay" />
      </div>

      {/* 
         NOTE: We removed the <nav> here because <Header /> in App.jsx 
         now handles the navigation globally. 
      */}

      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1>
            Go where you're <br />
            treated best.
          </h1>

          <p className="subtitle">
            The intelligent platform for global mobility. We analyze your
            profile to find the perfect visa, job, and tax setup abroad.
          </p>

          <div className="cta-group">
            <button
              className="cta-primary"
              onClick={() => navigate(user ? "/analyze" : "/signup")}
            >
              {user ? "Go to Dashboard" : "Start Free Assessment"}{" "}
              <ArrowRight size={18} />
            </button>
          </div>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2025 Atlas Inc.</p>
      </div>
    </footer>
  );
}

export default Landing;